import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-square-action-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none">
      <path
        opacity="0.4"
        d="M9.46 0H3.87333C1.44667 0 0 1.44667 0 3.87333V9.45333C0 11.8867 1.44667 13.3333 3.87333 13.3333H9.45333C11.88 13.3333 13.3267 11.8867 13.3267 9.46V3.87333C13.3333 1.44667 11.8867 0 9.46 0Z"
        fill="currentColor" />
      <path
        d="M7 4V10M4 7H10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round" />
    </svg>
  `,
})
export class SquareActionIconComponent extends BaseIconComponent {
  override readonly width = input<string>('14');
  override readonly height = input<string>('14');
  override readonly viewBox = input<string>('0 0 14 14');
}
